import React from 'react';
import { GroupLabel } from 'components/MenuList';
import useUniqueId from 'hooks/useUniqueId';
var MenuItemGroup = function MenuItemGroup(_ref) {
  var label = _ref.label,
    id = _ref.id,
    children = _ref.children;
  var uniqueId = useUniqueId(id);
  return /*#__PURE__*/React.createElement("div", {
    "aria-labelledby": uniqueId,
    role: "group"
  }, /*#__PURE__*/React.createElement(GroupLabel, {
    id: uniqueId
  }, label), children);
};
export default MenuItemGroup;